const config = {
    build_number: '616427',
    build_timestamp: '2026-09-29T01:01:58.422Z',
    build_commit: 'c7ec67d7b51517c9ed65f1cd74090ddd669efe5f',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
